module.exports = __webpack_public_path__ + "static/avatar-e5a44970883a571a40cb950e6afb1a7b.jpg";